const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const daysInMs = 1000 * 60 * 60 * 24;
const hoursInMs = 1000 * 60 * 60;
const minutesInMs = 1000 * 60;

const isExpired = (expireDate: number) => expireDate <= Date.now();

const getDiff = (endDate: number) => endDate - Date.now();

const isExpiresInOneDay = (expireDate: number) =>
  Math.floor((expireDate - Date.now()) / (60 * 60 * 1000)) < 24;

export {
  isExpired,
  getDiff,
  isExpiresInOneDay,
  months,
  daysInMs,
  hoursInMs,
  minutesInMs
};
